module.exports = __webpack_public_path__ + "static/media/luz03.e243a781.jpg";